import { clsx } from 'clsx';
import { FC } from 'react';
import { QuantitySelect } from 'molecules/QuantitySelect';
import styles from './styles.module.css';

export const ProductQuantitySelect: FC<{
  quantityLimit: number;
  setQuantity: (q: number) => void;
  isOutOfStock: boolean;
  className?: string;
  disabled?: boolean;
}> = ({ quantityLimit, setQuantity, isOutOfStock, className }) => {
  return (
    <QuantitySelect
      limit={quantityLimit}
      onChange={(e) => setQuantity(Number(e.target.value))}
      className={clsx(styles.select, className, {
        [styles.selectQuantityDisabled]: isOutOfStock,
      })}
      disabled={isOutOfStock}
    />
  );
};
